import React, { useEffect, useState } from "react";
import "../../../assets/css/mycart.css";
import { FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  checkSessionValidity,
  getSampleCurrencyFormat,
} from "../../../utils/utils";
import {
  saveaddtoproductcart,
  savecustomerresult,
} from "../../../features/HomePageSlice/homeDataSlice";
import {
  REMOVE_PRODUCT,
  GET_CUSTOMER_CART,
  UPDATE_CUSTOMER_CART,
  CUSTOMER_CART,
} from "../../../assets/graphql";
import { apiHandler } from "../../../api";
import { endpoint } from "../../../api/endpoint";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const MyCartLeft = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginUser = localStorage.getItem("loginURL");
  const { cartPrices,addtoproductcart, customerresult } = useSelector(
    (state) => state.home
  );
  // console.log(addtoproductcart);
  const { token } = useSelector((state) => state.login);

  useEffect(() => {
    if (customerresult && customerresult.id) {
      getLatestCartInfo(customerresult.id);
    }
  }, [customerresult]);
  const getLatestCartInfo = async (cartId) => {
    if (token) {
      setLoader(true);
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          query: GET_CUSTOMER_CART,
          variables: { cart_id: cartId },
        },
      });

      setLoader(false);
      if (!result.data.message) {
        dispatch(saveaddtoproductcart(result.data.cart));
      } else if (
        result.data.message &&
        result.data.message.data &&
        result.data.message.data.cart
      ) {
        dispatch(saveaddtoproductcart(result.data.message.data.cart));
      } else {
        const customerresult = await apiHandler({
          url: endpoint.GRAPHQL_URL,
          method: "POST",
          authToken: token,
          data: {
            base_url: endpoint.API_BASE_URL,
            query: CUSTOMER_CART,
            variables: {},
          },
        });
        checkSessionValidity(customerresult.data, dispatch);
        if (!customerresult.data.error_code) {
          dispatch(savecustomerresult(customerresult.data.customerCart));
        }
      }
    } else {
      if(loginUser) {
        navigate(`/${loginUser}`)
      } else {
        navigate("/default");
      }
      // navigate("/default");
    }
  };
  const RemoveToCart = async (id) => {
    if (token) {
      setLoader(true);
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {
            cart_id: customerresult.id,
            cart_item_id: id,
          },
          query: REMOVE_PRODUCT,
        },
      });
      checkSessionValidity(result.data, dispatch);
      setLoader(false);
      if (result.data.message && result.data.message.errors) {
        if (
          result.data.message.errors[0] &&
          result.data.message.errors[0].message
        ) {
          toast.error(result.data.message.errors[0].message);
        }
      } else {
        toast.success("Deleted Successfully");
        getLatestCartInfo(customerresult.id);
      }
    } else {
        if(loginUser) {
            navigate(`/${loginUser}`)
        } else {
            navigate("/default");
        }
      // navigate("/default");
    }
  };
  const ReduceQuantity = async (uid, quantity) => {
    if (token) {
      setLoader(true);
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          query: UPDATE_CUSTOMER_CART,
          variables: {
            cart_id: customerresult.id,
            cart_item_uid: uid,
            quantity: quantity - 1,
          },
        },
      });
      checkSessionValidity(result.data, dispatch);
      setLoader(false);
      if (
        result &&
        result.data &&
        result.data.message &&
        result.data.message.errors &&
        result.data.message.errors[0] &&
        result.data.message.errors[0].message
      ) {
        toast.error(result.data.message.errors[0].message);
      } else if (!result.data.message) {
        getLatestCartInfo(customerresult.id);
      }
    } else {
      if(loginUser) {
        navigate(`/${loginUser}`)
      } else {
          navigate("/default");
      }
      // navigate("/default");
    }
  };
  const AddQuantity = async (uid, quantity) => {
    if (token) {
      setLoader(true);
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          query: UPDATE_CUSTOMER_CART,
          variables: {
            cart_id: customerresult.id,
            cart_item_uid: uid,
            quantity: quantity + 1,
          },
        },
      });
      checkSessionValidity(result.data, dispatch);
      setLoader(false);
      if (
        result &&
        result.data &&
        result.data.message &&
        result.data.message.errors &&
        result.data.message.errors[0] &&
        result.data.message.errors[0].message
      ) {
        toast.error(result.data.message.errors[0].message);
      } else if (!result.data.message) {
        getLatestCartInfo(customerresult.id);
      }
    } else {

      if(loginUser) {
        navigate(`/${loginUser}`)
      } else {
          navigate("/default");
      }
      // navigate("/default");
    }
  };

  return (
    <>
    
      {addtoproductcart &&
        addtoproductcart.map((cartitem, index) =>
          cartitem ? (
            <div className="product_single_box cart_page ">
              <div className="cart_prod_row">
                <div className="product_img">
                  <a href={"/#/product-detail/" + cartitem.product.sku}>
                    <img
                      src={
                        cartitem.configured_variant &&
                        cartitem.configured_variant.image &&
                        cartitem.configured_variant.image.url
                          ? cartitem.configured_variant.image.url
                          : cartitem.product.image && cartitem.product.image.url
                          ? cartitem.product.image.url
                          : ""
                      }
                      alt=""
                    />
                  </a>
                </div>
                <div className="other_details">
                  <div className="product_name">
                    <a href={"/#/product-detail/" + cartitem.product.sku}>
                      {cartitem.product.name}
                    </a>
                  </div>
                  <div className="product_price_row">
                    <div className="final_price">
                      Price:{" "}
                      {getSampleCurrencyFormat(
                        cartitem.product.price_range &&
                          cartitem.product.price_range.minimum_price &&
                          cartitem.product.price_range.minimum_price
                            .final_price &&
                          cartitem.product.price_range.minimum_price.final_price
                            .currency
                          ? cartitem.product.price_range.minimum_price
                              .final_price.currency
                          : "INR",
                        cartitem.prices &&
                          cartitem.prices.price &&
                          cartitem.prices.price.value
                          ? cartitem.prices.price.value
                          : 0
                      )}
                     
                    </div>
                    {cartitem.configurable_options &&
                      cartitem.configurable_options.map((opt, i) => (
                        <small key={i} className="d-block text-muted">
                          {opt.option_label}: {opt.value_label}{" "}
                        </small>
                      ))}
                    {cartitem.customizable_options &&
                      cartitem.customizable_options.map((option, i) => (
                        <>
                          <div style={{ display: "flex" }}>
                            <div>{option.label ? option.label : ""} &nbsp;</div>
                            <div>
                              {option.values.map((val, i) => (
                                <div> ({val.label ? val.label : ""})</div>
                              ))}
                            </div>
                          </div>
                        </>
                      ))}
                  </div>
                  <div className="cart_options">
                    <div className="cart_qty">
                      Qty:{" "}
                      <button
                        onClick={() =>
                          ReduceQuantity(cartitem.uid, cartitem.quantity)
                        }
                        style={{ border: "none" }}
                      >
                        {" "}
                        -{" "}
                      </button>{" "}
                      {cartitem.quantity}{" "}
                      <button
                        onClick={() =>
                          AddQuantity(cartitem.uid, cartitem.quantity)
                        }
                        style={{ border: "none" }}
                      >
                        {" "}
                        +{" "}
                      </button>
                    </div>
                    <div
                      className="delete_prod"
                      onClick={() => RemoveToCart(cartitem.id)}
                    >
                      <i>
                        <FaTrash />
                      </i>{" "}
                      Remove
                    </div>
                  </div>
                </div>
                <div className="delivery_info">
                  <div className="delivery_details">
                    <img src="img/delivery.jpg" alt="" />
                  </div>
                  {/* <div className="return_policy">
                    <b>
                      Bank Cashback & EMI Details Available  on Payment Page                     
                    </b>
                  </div> */}
                </div>
              </div>
              {cartitem.errors &&
                cartitem.errors[0] &&
                cartitem.errors[0].code &&
                cartitem.errors[0].code === "ITEM_QTY" && (
                  <div style={{ color: "red", fontWeight: "500" }}>
                    <strong>{cartitem.errors[0].message}</strong>
                  </div>
                )}
            </div>
          ) : null
        )}

      {loader && (
        <div className="loading-overlay">
          <div className="bounce-loader">
            {/* <div className='bounce1'></div>
								<div className='bounce2'></div>
								<div className='bounce3'></div> */}
            <div className="loader"></div>
          </div>
        </div>
      )}
    </>
  );
};
export default MyCartLeft;
